import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import AsyncStorage from '@react-native-async-storage/async-storage'

interface UseCurrentUserState {
  userID: string
  setUserID: (newUserID: string) => void
  resetUserID: () => void
}

export const useCurrentUserStore = create<UseCurrentUserState>()(
  persist(
    (set) => ({
      userID: '',
      setUserID: (newUserID: string) => set({ userID: newUserID }),
      resetUserID: () => set({ userID: '' }),
    }),
    { name: 'currentUserStore', storage: createJSONStorage(() => AsyncStorage) },
  ),
)
